<div class="content-with-stepper-and-title">
  <main>
    <h1 id="generalTitle" class="sub-title offset-inline selfie-title" [innerHtml]="copyService.copies.virtual_card_franchise"></h1>
    <div class="content-checkbox">
      <voxel-radio-button-group id="productList">
        <voxel-radio-button radioName="listproduct" *ngFor="let products of listProducts" [id]="products.elementId" [checked]="products.checked" (radioButtonChange)="onRadioChange($event)" [value]="products">
          {{products.label}}
        </voxel-radio-button>
      </voxel-radio-button-group>
    </div>
  </main>
  <app-controls id="payDayBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.form_contact_btn" [nextDisabled]="!enableButtonNext" (only_previous)="sendBackButtonEvent()" (next)="next()"></app-controls>
</div>